import(/* webpackMode: "eager", webpackExports: ["ConsultHeader"] */ "/app/app/consultation/sections/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.21_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
